import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import ViewWidget from "./ViewWidget";
import ObsWidget from "./ObsWidget";
import cloneDeep from "lodash/cloneDeep";

const ZAXIS_WIDTH = 3.5;

const SRC_ID_DEFAULTS = {
  8: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 2.5},
    obs_widget: {distinct_view: true, zaxis_min: null, zaxis_max: null, vignette_function: false, radial_power: 0, log_transform: true, symmetric: false}
  },
  9: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 3.0},
    obs_widget: {distinct_view: true, zaxis_min: null, zaxis_max: null, vignette_function: false, radial_power: 0, log_transform: true, symmetric: false}
  },
  10: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 4.0},
    obs_widget: {distinct_view: true, zaxis_min: null, zaxis_max: null, vignette_function: false, radial_power: 0, log_transform: true, symmetric: false}
  },
  11: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 4.5},
    obs_widget: {distinct_view: true, zaxis_min: null, zaxis_max: null, vignette_function: false, radial_power: 0, log_transform: true, symmetric: false}
  },
  12: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 4.0},
    obs_widget: {distinct_view: true, zaxis_min: null, zaxis_max: null, vignette_function: false, radial_power: 0, log_transform: true, symmetric: false}
  },
  84: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 4.5},
    obs_widget: {distinct_view: false}
  },

}


const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  view_widget: {},
  obs_widget: {}
}

const DEFAULTS = {
  sim_widget: {
    domain: 'cor',
    time_of_interest: null,
  },
  obs_widget: {
    src_id: 10,
    quality_check: false,
    distinct_view: true,
    radial_power: 0,
    vignette_function: false,
    log_transform: true,
    zaxis_min: null,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: false,
    symmetric_value: null,
  },
  slice_widget: {
    radial_power: 0,
    vignette_function: false,
    log_transform: true,
  },
  view_widget: {
    zaxis_min: 0.5,
    zaxis_max: 4,
    zaxis_ticks: null,
    symmetric: false,
    symmetric_value: null,
    grid: null,
  },
}

const flagTriggers = {
  obs_widget: {src_id: true},
}

const flagValidators = (widget, k, v, dependencies) => {
  let modifiedParams = cloneDeep(SRC_ID_DEFAULTS[v])
  modifiedParams[widget][k] = v;
  modifiedParams.view_widget.zaxis_min = modifiedParams.view_widget.zaxis_max ? modifiedParams.view_widget.zaxis_max - ZAXIS_WIDTH : null;
  return { widget_: "_", params_: modifiedParams };
};

const EuvComparison = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='euv_comparison'
        toolName='EUV Comparison'
        flagTriggers={flagTriggers}
        flagValidators={flagValidators}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        viewWidget={ViewWidget}
        obsWidget={ObsWidget}
      />
    </>

  )
}

export default EuvComparison;